import type { Step } from '../types/step';
import { getAddMaintenanceReminderSteps } from '../common/addmaintenance';

/**
 * Steps for adding maintenance reminders before onboarding
 */
export const AddMaintenanceReminderBeforeOnboardingSteps: Step[] = getAddMaintenanceReminderSteps({
  flowFilter: (appData) => {
    // Don't show the prompt if insurance is selected. It will be asked in the onboarding section.
    // If insurance is selected, ask these questions in the onboarding section.
    if (appData.selectedService?.insurance) {
      return false;
    }

    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }

    return !!appData.serviceSplitSelectedService?.garage;
  },
});
